import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { GiCrossedBones } from 'react-icons/gi';
import { LuSave } from 'react-icons/lu';
import { submitMotorProductMaster } from "../../../../services/apiService";
import InsurerDropdown from "../../../../utils/Insurer";

const AddMotorProduct = () => {
  const [isRenewableEnabled, setIsRenewableEnabled] = useState(false);
  const [isMemberEnabled, setIsMemberEnabled] = useState(false);
  const [selectedYears, setSelectedYears] = useState(1);

  // Form Validation Schema
  const validationSchema = Yup.object({
    insurer: Yup.string().required("Insurer is required"),
    productName: Yup.string().required("Product Name is required"),
  });

  //   const generateRandomNumber = () => {
  //     return Math.floor(Math.random() * 90) + 10; // Generates a number between 10 and 99
  //   };

  // Submit Whole Form
  const handleSubmit = async (values, { resetForm }) => {
    try {
      const formattedData = {
        TObject: {
          Motor_Product_ID: 0, // assuming new product
          InsurerId: parseInt(values.insurer), // ensure it's a number
          Motor_Product_Name: values.productName,
          Motor_Product_ShortName: values.productShortName,
          NoOfYears: `${selectedYears} yrs`,
          CreatedBy: 1,
        }
      };

      // Call API
      await submitMotorProductMaster(formattedData);

      alert("Form submitted successfully!");

      // Reset form after successful submission
      resetForm();
      setSelectedYears(1);
    } catch (error) {
      console.error("Form submission failed:", error);
    }
  };

  const handleSelectedYear = (value) => {
    setSelectedYears(value);
  }

  return (
    <div className="formContainer lg:p-4">
      <div className="flex flex-col lg:mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>
        <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-3  ">Motor Product Master</h5>

        {/* Formik Form */}
        <Formik
          initialValues={{
            insurer: "",
            productName: "",
            productShortName: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form id="motorProductForm">
              <div className="flex flex-wrap -mx-2">
                <div className="w-full md:w-1/2 mb-3">
                  <InsurerDropdown name="insurer" insurerType='L' />
                </div>

                <div className="w-full md:w-1/2 mb-3">
                  <label className="form-label">Product Name <span className="text-danger">*</span>
                  </label>
                  <Field type="text" name="productName" className="form-control custom-shadow w-full px-3 py-2" />
                  <ErrorMessage name="productName" component="div" className="text-red-600 text-sm mt-1" />
                </div>

                <div className="w-full md:w-1/2 mb-3">
                  <label className="form-label">Product Short Name </label>
                  <Field type="text" name="productShortName" className="form-control custom-shadow w-full px-3 py-2" />
                </div>

                <div className="w-full md:w-1/2  mb-3">
                  <label className="form-label mx-2">No of years</label>
                  <div className="d-flex gap-2 mx-2">
                    {[1, 2, 3].map((year) => (
                      <button
                        key={year}
                        type="button"
                        className={`toggle-btn ${selectedYears === year ? "active" : ""}`}
                        onClick={() => setSelectedYears(year)}
                      >
                        {year}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="d-flex justify-content-start gap-3 mt-5 justify-content-center">
                <button type="submit" className=" saveButton d-flex" disabled={isSubmitting}>
                  <span className="m-auto p-1"><LuSave /></span>{isSubmitting ? "Saving..." : "Save"}
                </button>
                <div className="flex gap-3">
                  <button type="button" className="d-flex backButton d-flex" onClick={() => window.history.back()}> <span className="m-auto p-1"><GiCrossedBones /></span>Cancel</button>
                </div>
              </div>
              {/* <div className="mt-4 d-flex justify-content-center">
              <button type="submit" className="btn btn-warning text-white" disabled={isSubmitting}>
                Save
              </button>
            </div> */}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddMotorProduct;